<div class="modal" [ngClass]="{'show' :config?.showTrialComparison}">

  <div class="modal-content">
    <div class="modal-content__body-container" [hidden]="activationPending">
      <div class="modal-header">
        <h3 [translate]="'eos-tv-shop-ii.title.trial-comparison'" class="no-margin-buttom"></h3>
        <div class="comparison-btns">
          <app-trial-comparison-button
            [x]="0"
            [y]="0"
            [ownerComponent]="ownerComponent"
            [trial]="trials?.length>0? trials[0]: undefined"
            (emitActivationPending)="setActivationPending($event)"
            (emitTrialActivation)="setActivatedTrial($event)"
            (emitTrialTimeOut)="setTimeOut($event)"
          ></app-trial-comparison-button>
          <span [translate]="'eos-tv-shop-ii.lbl.trial-comparison-or'"></span>
          <app-trial-comparison-button
            [x]="1"
            [y]="0"
            [ownerComponent]="ownerComponent"
            [trial]="trials?.length>1? trials[1]: undefined"
            (emitActivationPending)="setActivationPending($event)"
            (emitTrialActivation)="setActivatedTrial($event)"
            (emitTrialTimeOut)="setTimeOut($event)"
          ></app-trial-comparison-button>
        </div>
      </div>
    </div>
    <div class="modal-content__body-container" [hidden]="!activationPending">
      <div class="empty-container">
        <app-spinner-loader class="intern"></app-spinner-loader>
      </div>
    </div>
  </div>
</div>
